<template>
  <div
    id="app"
    class="woot-widget-wrap"
    :class="{
      'is-mobile': chatTabProps.isMobile,
      'is-widget-right': !chatTabProps.isLeftAligned,
      'is-bubble-hidden': chatTabProps.hideMessageBubble,
    }"
  >
    <home
      v-if="showHomePage"
      :has-fetched="chatTabProps.hasFetched"
      :unread-message-count="chatTabProps.unreadMessageCount"
      :show-popout-button="chatTabProps.showPopoutButton"
      :chat-tab-props="chatTabProps"
    />
    <unread
      v-else
      :show-unread-view="chatTabProps.showUnreadView"
      :has-fetched="chatTabProps.hasFetched"
      :unread-message-count="chatTabProps.unreadMessageCount"
      :hide-message-bubble="chatTabProps.hideMessageBubble"
    />
  </div>
</template>

<script>
export default {
  name: 'Chat',
  components: {
    Home: () => import("./Home"),
    Unread:() => import("./Unread"),
  },
  props: {
    chatTabProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    showHomePage() {
      return !this.chatTabProps.showUnreadView && !this.chatTabProps.showCampaignView;
    },
  },
};
</script>